<template>
  <v-app>

    <Loading :status="isLoading" 
             :opacity="1"
             class="global-loading"
             :linear="isLoading=='linear'"
             background-color="white"
             color="grey"
             :size="50"
             :width="2"/>

    <router-view class="grey lighten-3"
                 style="min-height:100vh"/>

    <Growler/>

  </v-app>
</template>

<script>
import utility from '@/mixins/utility'

import { mapGetters } from 'vuex'

import Growler from '@/components/UI/Growler'
import Loading from '@/components/UI/Loading'

export default {
  name: 'App',

  mixins: [ utility ],

  components: {
    Growler,
    Loading
  },

  data: () => ({
    //
  }),

  computed:
  {
    ...mapGetters({
      isLoading: 'ui/isLoading'
    })
  },

  mounted()
  {

  },

  methods:
  {
    
  },

  watch:
  {
    
  }
};
</script>
